/* Uses the existing Shopify product form, variant resolver and cart sections. */
(() => {
  if (window.KitsPrimeProduct) return;
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const selectedAddons = (root) => [...root.querySelectorAll('[data-kp-addon]:checked')].filter(el => !el.disabled);
  const buildPayload = (formData, addons, title, group) => {
    const quantity = Number(formData.get('quantity') || 1);
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match) properties[match[1]] = value;
    }
    const parent = { id: formData.get('id'), quantity, properties: { ...properties, _kp_group: group } };
    if (formData.get('selling_plan')) parent.selling_plan = formData.get('selling_plan');
    const items = [parent, ...addons.map(addon => ({
      id: addon.dataset.id, quantity,
      properties: { 'Para': title, ...properties, _kp_group: group }
    }))];
    return { items, sections: formData.get('sections') || undefined, sections_url: formData.get('sections_url') || undefined };
  };
  window.KitsPrimeProduct = { selectedAddons, buildPayload };

  class Extras extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', () => this.update());
      this.addEventListener('input', () => this.preview());
      this.update();
    }
    update() {
      const checked = this.querySelector('[data-kp-personalize]')?.checked || false;
      const panel = this.querySelector('.kpp-personalize');
      if (panel) {
        panel.hidden = !checked;
        panel.querySelectorAll('input').forEach(input => { input.disabled = !checked; input.required = checked; });
      }
      const patches = [...this.querySelectorAll('[data-kp-patch]:checked')].map(el => el.dataset.label);
      const field = this.querySelector('[data-kp-patch-property]');
      if (field) { field.value = patches.join(', '); field.disabled = !patches.length; }
      this.preview();
      this.dispatchEvent(new CustomEvent('kp:extras', { bubbles: true }));
    }
    preview() {
      setText(this.querySelector('[data-kp-preview-name]'), this.querySelector('[name="properties[Nombre]"]')?.value.trim().toUpperCase() || 'TU NOMBRE');
      setText(this.querySelector('[data-kp-preview-number]'), this.querySelector('[name="properties[Dorsal]"]')?.value || '10');
    }
  }

  class ProductControls extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.form = document.getElementById(this.dataset.form);
      if (!this.root || !this.form) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.hasPickedSize = new URL(location.href).searchParams.has('variant');
      this.bar = this.querySelector('.kpp-sticky');
      this.button = this.querySelector('[data-kp-sticky-add]');
      this.error = this.querySelector('[data-kp-error]');
      this.form.before(this.error);
      this.root.addEventListener('change', event => {
        if (event.target.matches('variant-selects input, variant-selects select')) {
          const name = event.target.dataset.optionName || event.target.name || '';
          if (/talla|taille|size/i.test(name)) this.hasPickedSize = true;
          this.error.hidden = true;
        }
        this.schedule();
      }, opts);
      this.root.addEventListener('click', event => {
        if (event.target.matches('variant-selects input[type="radio"]') && /talla|taille|size/i.test(event.target.dataset.optionName || event.target.name || '')) {
          this.hasPickedSize = true;
          this.error.hidden = true;
          this.schedule();
        }
      }, opts);
      this.root.addEventListener('kp:extras', () => this.sync(), opts);
      this.root.addEventListener('submit', event => {
        if (event.target !== this.form) return;
        if (!this.validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { ...opts, capture: true });
      this.button.addEventListener('click', () => {
        if (!this.validate()) return;
        this.nativeButton?.click();
      }, opts);
      this.observer = new MutationObserver(records => {
        if (records.some(r => !this.contains(r.target) && !r.target.closest?.('kp-extras'))) this.schedule();
      });
      this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      this.intersection = new IntersectionObserver(entries => {
        this.bar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      });
      const native = this.nativeButton;
      if (native) this.intersection.observe(native);
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); cancelAnimationFrame(this.frame);
    }
    get nativeButton() { return this.form?.querySelector('[type="submit"]'); }
    get sizeField() {
      return [...this.root.querySelectorAll('variant-selects input[type="radio"], variant-selects select')]
        .find(el => /talla|taille|size/i.test(el.dataset.optionName || el.name || ''));
    }
    validate() {
      if (this.sizeField && !this.hasPickedSize) {
        this.error.textContent = 'Elige tu talla antes de añadir la camiseta al carrito.';
        this.error.hidden = false;
        const target = this.sizeField.closest('fieldset, .product-form__input') || this.sizeField;
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        this.sizeField.focus({ preventScroll: true });
        return false;
      }
      if (!this.form.reportValidity()) return false;
      this.error.hidden = true;
      return true;
    }
    schedule() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.sync()); }
    sync() {
      const native = this.nativeButton;
      if (!native) return;
      const busy = native.disabled || native.getAttribute('aria-disabled') === 'true';
      this.button.disabled = busy;
      const label = busy ? native.textContent.trim() : this.sizeField && !this.hasPickedSize ? 'Elegir talla' : 'Añadir al carrito';
      setText(this.button, label || 'Selecciona una opción');
      let price = Number(this.dataset.initialPrice);
      try {
        const variant = JSON.parse(this.root.querySelector('variant-selects [type="application/json"]')?.textContent || 'null');
        if (variant) price = variant.price;
      } catch (_) { /* Retain initial server price if the picker has no JSON yet. */ }
      const extraPrice = selectedAddons(this.root).reduce((sum, el) => sum + Number(el.dataset.price), 0);
      const currency = new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      const formatted = currency.format((price + extraPrice) / 100);
      setText(this.querySelector('[data-kp-sticky-price]'), formatted);
      setText(this.root.querySelector('[data-kp-total]'), formatted);
      const total = this.root.querySelector('.kpp-total');
      if (total) total.hidden = extraPrice === 0;
    }
  }
  class Marquee extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('button')?.addEventListener('click', event => {
        const paused = this.toggleAttribute('data-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        event.currentTarget.textContent = paused ? 'Reanudar movimiento' : 'Pausar movimiento';
      });
    }
  }
  class Carousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.kpp-carousel-track');
      if (!this.track || !this.track.children.length) return;
      this.cards = [...this.track.children];
      this.originalCards = [...this.cards];
      this.loop = this.dataset.loop === 'true' && this.cards.length > 2;
      this.abort = new AbortController();
      this.pausedByUser = new WeakSet();
      this.centered = this.dataset.stories === 'true';
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.index = 0;
      const options = { signal: this.abort.signal };
      this.querySelector('[data-kpp-prev]')?.addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-kpp-next]')?.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        this.scheduleCarousel();
        this.scheduleRebalance();
      }, { ...options, passive: true });
      this.track.addEventListener('pointerdown', () => { this.dragging = true; }, { ...options, passive: true });
      const release = () => { this.dragging = false; this.scheduleRebalance(); };
      document.addEventListener('pointerup', release, { ...options, passive: true });
      document.addEventListener('pointercancel', release, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.cards.forEach(card => {
        const video = card.querySelector('video');
        if (!video) return;
        const actions = card.querySelector('.kpp-video-actions');
        if (actions) { actions.hidden = false; video.controls = false; }
        card.querySelector('[data-kpp-play]')?.addEventListener('click', () => {
          if (video.paused) { this.pausedByUser.delete(video); this.play(video); }
          else { this.pausedByUser.add(video); video.pause(); }
        }, options);
        card.querySelector('[data-kpp-mute]')?.addEventListener('click', () => {
          video.muted = !video.muted; this.videoState(card, video);
        }, options);
        video.addEventListener('play', () => this.videoState(card, video), options);
        video.addEventListener('pause', () => this.videoState(card, video), options);
        video.addEventListener('volumechange', () => this.videoState(card, video), options);
        this.videoState(card, video);
      });
      document.addEventListener('visibilitychange', () => this.syncVideos(), options);
      this.resize = new ResizeObserver(() => this.scheduleCarousel());
      this.resize.observe(this.track);
      if (this.centered) {
        this.visibility = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.4;
          this.syncVideos();
        }, { threshold: [0, 0.4, 0.7] });
        this.visibility.observe(this.track);
      }
      this.refresh();
      if (this.loop || this.centered && this.dataset.initialIndex !== undefined) {
        this.initialFrame = requestAnimationFrame(() => {
          const initial = Math.max(0, Math.min(this.cards.length - 1, Number(this.dataset.initialIndex) || 0));
          if (this.loop) {
            this.track.setAttribute('data-kp-rebasing', '');
            this.rotateToMiddle(this.originalCards[initial]);
          }
          this.scrollToIndex(this.loop ? Math.floor(this.cards.length / 2) : initial, 'instant');
          this.refresh();
          this.restoreSnap();
        });
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initialFrame);
      cancelAnimationFrame(this.snapFrame);
      clearTimeout(this.settleTimer);
      this.abort?.abort(); this.resize?.disconnect(); this.visibility?.disconnect();
      cancelAnimationFrame(this.carouselFrame);
      this.cards?.forEach(card => card.querySelector('video')?.pause());
      this.track?.removeAttribute('data-kp-rebasing');
      if (this.loop) this.originalCards.forEach(card => this.track.append(card));
    }
    scheduleRebalance() {
      if (!this.loop) return;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => {
        if (!this.dragging) { this.refresh(); this.rebalance(); }
      }, 160);
    }
    rotateToMiddle(active) {
      const middle = Math.floor(this.cards.length / 2);
      while (this.cards.indexOf(active) > middle) {
        this.track.append(this.cards.shift());
        this.cards = [...this.track.children];
      }
      while (this.cards.indexOf(active) < middle) {
        this.track.prepend(this.cards.pop());
        this.cards = [...this.track.children];
      }
      this.index = middle;
    }
    restoreSnap() {
      cancelAnimationFrame(this.snapFrame);
      this.snapFrame = requestAnimationFrame(() => this.track.removeAttribute('data-kp-rebasing'));
    }
    rebalance() {
      if (!this.loop || this.dragging || this.index === Math.floor(this.cards.length / 2)) return;
      // Rotate off-screen originals, preserving the active card and its video state.
      // No cloned reviews, duplicate IDs, or extra video downloads are needed.
      const active = this.cards[this.index];
      const before = active.getBoundingClientRect();
      const anchor = rect => this.centered ? rect.left + rect.width / 2 : rect.left;
      this.track.setAttribute('data-kp-rebasing', '');
      this.rotateToMiddle(active);
      const delta = anchor(active.getBoundingClientRect()) - anchor(before);
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'instant' });
      this.refresh();
      this.restoreSnap();
    }
    scheduleCarousel() {
      cancelAnimationFrame(this.carouselFrame);
      this.carouselFrame = requestAnimationFrame(() => this.refresh());
    }
    refresh() {
      const rect = this.track.getBoundingClientRect();
      const anchor = this.centered ? rect.left + rect.width / 2 : rect.left;
      let nearest = Infinity;
      this.cards.forEach((card, i) => {
        const item = card.getBoundingClientRect();
        const distance = Math.abs((this.centered ? item.left + item.width / 2 : item.left) - anchor);
        if (distance < nearest) { nearest = distance; this.index = i; }
      });
      const canScroll = this.track.scrollWidth > this.track.clientWidth + 2;
      const nav = this.querySelector('.kpp-carousel-nav');
      if (nav) nav.hidden = !canScroll;
      const prev = this.querySelector('[data-kpp-prev]'), next = this.querySelector('[data-kpp-next]');
      if (prev) prev.disabled = !canScroll || !this.loop && this.track.scrollLeft <= 2;
      if (next) next.disabled = !canScroll || !this.loop && this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      setText(this.querySelector('[data-kpp-position]'), `${this.loop ? this.originalCards.indexOf(this.cards[this.index]) + 1 : this.index + 1} / ${this.cards.length}`);
      this.cards.forEach((card, i) => card.classList.toggle('is-current', i === this.index));
      this.syncVideos();
    }
    move(direction) {
      if (this.loop) { this.refresh(); this.rebalance(); }
      const step = Number(this.dataset.step || 1);
      this.scrollToIndex(this.index + direction * step, this.reducedMotion.matches ? 'auto' : 'smooth');
    }
    scrollToIndex(targetIndex, behavior = 'auto') {
      const index = Math.max(0, Math.min(this.cards.length - 1, targetIndex));
      const item = this.cards[index].getBoundingClientRect(), track = this.track.getBoundingClientRect();
      const left = this.track.scrollLeft + item.left - track.left - (this.centered ? (this.track.clientWidth - item.width) / 2 : 0);
      this.track.scrollTo({ left, behavior });
    }
    play(video) {
      const result = video.play();
      result?.catch(() => { /* Autoplay may be blocked; the play button remains available. */ });
    }
    syncVideos() {
      if (!this.centered) return;
      this.cards.forEach((card, i) => {
        const video = card.querySelector('video');
        if (!video) return;
        if (!this.visible || document.hidden || i !== this.index) { if (!video.paused) video.pause(); }
        else if (video.paused && !this.reducedMotion.matches && !this.pausedByUser.has(video)) this.play(video);
      });
    }
    videoState(card, video) {
      const play = card.querySelector('[data-kpp-play]'), mute = card.querySelector('[data-kpp-mute]');
      if (play) {
        play.setAttribute('aria-label', video.paused ? 'Reproducir vídeo' : 'Pausar vídeo');
        play.setAttribute('aria-pressed', String(!video.paused));
        play.innerHTML = video.paused ? '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m7 3 15 9-15 9z"/></svg>' : '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M5 3h5v18H5zm9 0h5v18h-5z"/></svg>';
      }
      if (mute) {
        mute.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar vídeo');
        mute.setAttribute('aria-pressed', String(!video.muted));
        mute.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 9h4l5-5v16l-5-5H3z"/>' + (video.muted ? '<path d="m16 9 6 6m0-6-6 6"/>' : '<path d="M16 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/>') + '</svg>';
      }
    }
  }
  if (!customElements.get('kp-carousel')) customElements.define('kp-carousel', Carousel);

  if (!customElements.get('kp-extras')) customElements.define('kp-extras', Extras);
  if (!customElements.get('kp-product-controls')) customElements.define('kp-product-controls', ProductControls);
  if (!customElements.get('kp-marquee')) customElements.define('kp-marquee', Marquee);
})();
